const initialDocumentsState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
  selectedDocument : [],

};

export const documentsReducer = (state = initialDocumentsState, action) => {
  switch (action.type) {
    case "FETCH_DOCUMENTS_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "FETCH_DOCUMENTS_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        nbResult: nbResult
      };
    }

    case "SET_SELECTED_DOCUMENTS_ROWS": {
      return {...state, selectedDocument: action.payload};
    }

    case "FETCH_DOCUMENTS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        nbResult: 0,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/documents.js